"use client"

import "./About.css"

const About = ({ language }) => {
  const content = {
    en: {
      title: "About Governor Abba Kabir Yusuf",
      sections: [
        {
          heading: "Early Life and Education",
          content:
            "Abba Kabir Yusuf (born Abubakar) was born on January 5, 1963 into the Sullubawa Fulani clan — the traditional ruling class of Kano Emirate — in Gaya LGA. He began his Islamic studies under his grandfather Alhaji Yusuf Bashari.\n\nHe attended Sumaila Primary School (1968–1975), Government Secondary School Dawakin Tofa and later Lautai in Gumel (graduated 1980). He holds ND and HND in Civil Engineering (1985, 1989), then gained PGD and MBA from Bayero University Kano.",
        },
        {
          heading: "Career",
          content:
            "Yusuf completed his NYSC at KEPA (1989–1990). He worked at WRECA in multiple engineering roles. Under President Umaru Musa Yar’adua, he served as Chairman of the Governing Board of NIEPA (2009–2011), contributing to educational development.",
        },
        {
          heading: "Political Career",
          content:
            "Yusuf became Personal Assistant to Engr. Rabiu Musa Kwankwaso during his tenure as Governor (1999–2003) and later as Minister of Defence (2003–2007). When Kwankwaso returned in 2011, he appointed Yusuf as Commissioner for Works, Housing & Transport.\n\nHe contested for Governor in 2019 under PDP. In 2022, he joined NNPP and swept the state with the Kwankwasiyya Movement behind him. He was declared Governor on March 20, 2023 and sworn in on May 29, 2023.",
        },
      ],
      governorPowersTitle: "Powers & Responsibilities of the Governor",
      powers: [
        "Managing state budget & financial decisions",
        "Appointing commissioners and key leadership positions",
        "Launching development projects & public service reforms",
        "Maintaining law, order and the welfare of citizens",
        "Representing Kano in national affairs",
      ],
      limitationsTitle: "Limitations of the Governor",
      limitations: [
        "Cannot override Federal laws or the Constitution",
        "State security remains controlled largely by the Federal Government",
        "Judiciary decisions cannot be interfered with",
        "Must work with the State Assembly for approvals",
      ],
      reelectionTitle: "Why Governor Abba Kabir Yusuf Should be Re-elected",
      reelectionReasons: [
        "He prioritizes the welfare of ordinary citizens",
        "A champion of education through mass school renovations",
        "Reviving public healthcare & job opportunities",
        "Restoring justice by returning public properties",
        "Unwavering commitment to transparent governance",
        "Extensive rural development and agricultural empowerment",
      ],
    },

    ha: {
      title: "Tarihin Gwamna Abba Kabir Yusuf",
      sections: [
        {
          heading: "Farkon Rayuwa da Ilimi",
          content:
            "An haifi Abba Kabir Yusuf a 5 ga Janairu 1963 a cikin dangin Fulani Sullubawa — masu tsarin mulki na Kano — a Gaya LGA. Ya fara karatun Islamiyya ƙarƙashin kakansa Alhaji Yusuf Bashari.\n\nYa yi Sumaila Primary School (1968–1975), Government Secondary School Dawakin Tofa sannan Lautai a Gumel (ya kammala 1980). Ya samu ND da HND a Civil Engineering daga Mubi da Kaduna Polytechnic, sannan PGD da MBA daga Bayero University Kano.",
        },
        {
          heading: "Aiki",
          content:
            "Ya yi NYSC a KEPA (1989–1990). Ya yi aiki a WRECA a fannoni daban-daban. Ya jagoranci hukumar NIEPA a lokacin Shugaba Umaru Musa Yar’adua (2009–2011).",
        },
        {
          heading: "Siyasa",
          content:
            "An nada shi PA ga Kwankwaso lokacin gwamnatarsa ta farko (1999–2003) da lokacin ya zama Ministan Tsaro (2003–2007). A 2011 ya zama Kwamishinan Ayyuka, Gidaje da Sufuri.\n\nYa tsaya takara a 2019 a PDP. A 2022 ya koma NNPP inda ya yi nasara da goyon bayan Kwankwasiyya. An zabe shi Gwamna a ranar 18 ga Maris 2023 kuma an rantsar da shi ranar 29 ga Mayu 2023.",
        },
      ],
      governorPowersTitle: "Iko da Ayyukan Gwamna",
      powers: [
        "Kula da kasafin kuɗi da harkokin kuɗin jihar",
        "Nadawa da shugabanin ma’aikatu da hukumomi",
        "Ƙaddamar da manyan ayyukan cigaba",
        "Kula da tsaro da walwalar al’umma",
        "Wakiltar Kano a tarayya",
      ],
      limitationsTitle: "Hannayen Gwamna Sun Daɗe",
      limitations: [
        "Ba zai iya rushe dokokin tarayya ba",
        "Tsaron jihar yana ƙarƙashin ikon tarayya sosai",
        "Ba zai tsoma baki a hukuncin kotu ba",
        "Dole ya yi aiki da Majalisar Dokoki",
      ],
      reelectionTitle: "Dalilan Sake Zaɓar Gwamna Abba",
      reelectionReasons: [
        "Yana kare talakawa da hakkinsu",
        "Gyaran makarantun talakawa da karanci",
        "Farfaɗo da kiwon lafiya da samar da ayyukan yi",
        "Maido da dukiyar al’umma daga barayi",
        "Nuna cikakken gaskiya a harkar mulki",
        "Bunkasa karkara da tallafawa harkar noma",
      ],
    },
  }

  const c = content[language]

  return (
    <div className="about">
      <div className="about-hero">
        <img
          src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/ABOUTPIC-1Kvw3FxKJUsB7HVDkZjBi1WIdknglJ.jpeg"
          alt="Governor at construction site"
          className="about-hero-image"
        />
      </div>

      <div className="about-container">
        <h1>{c.title}</h1>

        <div className="about-content">
          {c.sections.map((section, index) => (
            <div key={index} className="about-card" style={{ animationDelay: `${index * 0.1}s` }}>
              <h2>{section.heading}</h2>
              <p>{section.content}</p>
            </div>
          ))}
        </div>

        {/* ✅ Governor Power Section */}
        <div className="section-title">{c.governorPowersTitle}</div>
        <ul className="power-list">
          {c.powers.map((p, i) => (
            <li key={i}>{p}</li>
          ))}
        </ul>

        {/* ✅ Limitations Section */}
        <div className="section-title">{c.limitationsTitle}</div>
        <ul className="limitations-list">
          {c.limitations.map((l, i) => (
            <li key={i}>{l}</li>
          ))}
        </ul>

        {/* ✅ Re-election Section */}
        <div className="section-title">{c.reelectionTitle}</div>
        <ul className="reelection-list">
          {c.reelectionReasons.map((r, i) => (
            <li key={i}>{r}</li>
          ))}
        </ul>

        <div className="about-footer-image">
          <img
            src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/ABOUTPIC3-ShFWWJZYMPJnhPIKyYEKQnyVfpVKuL.jpg"
            alt="Governor at campaign event"
            className="footer-image"
          />
        </div>
      </div>
    </div>
  )
}

export default About
